import { z } from 'zod';
import { baseTaskSchema } from '../schema.base.js';
import { markWordsAudioInput } from './input.audio.js';
import { selectableWordInput } from './input.selectable-word.js';
import { markWordsWhitespaceInput } from './input.whitespace.js';

const selectAnswersMarkWordsTaskSchema = baseTaskSchema.extend({
  taskType: z.literal("SelectAnswers"),
  answerType: z.literal("MarkWords"),
  contents: z.array(z.preprocess(it => {
    if (!it || typeof it !== "object" || !("text" in it) || typeof it.text !== "string") {
      return it;
    }
    if (!it.text.trim()) {
      return {
        ...it,
        type: "Whitespace"
      };
    }
    return it;
  }, z.union([selectableWordInput.schema, markWordsWhitespaceInput.schema, markWordsAudioInput.schema])))
}).transform(({
  contents,
  ...rest
}) => {
  const content = (() => {
    const base = contents.map((it, index) => it.type !== "Word" ? it : selectableWordInput.postprocessSchemaInput(it, {
      taskId: rest.id,
      index
    }));

    //
    // STEP: Ensure that spaces are added between words as necessary due to
    // legacy editor concerns, as described in ADO #127404
    //
    const content = [];
    let prevSegment;
    for (const segment of base) {
      if (!prevSegment) {
        content.push(segment);
        prevSegment = segment;
        continue;
      }
      if (prevSegment.nodeType === "selectable-word-input" && segment.nodeType === "selectable-word-input" && !/ $/.test(prevSegment.text) && !/^ /.test(segment.text)) {
        content.push({
          id: "whitespace",
          nodeType: "mark-words-whitespace",
          type: "Whitespace",
          as: "space"
        });
      }
      content.push(segment);
      prevSegment = segment;
    }
    return content;
  })();
  return {
    ...rest,
    content
  };
});

export { selectAnswersMarkWordsTaskSchema };
//# sourceMappingURL=_schema.js.map
